/**
 * 常用正则表达式
 */

// 验证手机号
export const phoneRegExp = /^1\d{10}$/g;

// 验证姓名
export const nameReg = /^[\u4E00-\u9FA5]{2,4}$/;

/* 手机或者座机 */
export const landlineOrMobileRegExp = /^1\d{10}$|^\d{3,5}-\d{7,8}$/g;

// 验证邮箱
export const emailRegExp = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;

// 验证QQ
export const qqRegExp = /^[1-9]\d{4,9}$/;

// 验证微信号
export const wxRegExp = /^[a-zA-Z]{1}[-_a-zA-Z0-9]{5,19}$/;

// 验证邮编
export const zipCodeEegExp = /^[0-9]{6}$/;

//汉字字母数字_-
export const chineseLetterNumberEegExp = /^[A-Za-z0-9\u4e00-\u9fa5_-]+$/;

// 身份证
export const idRegExp = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;

// 营业执照
export const businessLicenseExp = /(^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$)|(^\d{15}$)/;

// 银行卡号
export const bankCardRegRxp = /^([1-9]{1})(\d{14}|\d{18})$/;

// 银行网点联行号
export const bankBranchNumber = /^\d{12}$/;

// 正整数(包括0,小数点)
export const isNumberRegExp = /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,6})?$/;

// 小数点
export const decimalPointErgExp = /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/;

// 数字字母
export const numberLetterRegExp = /^[A-Za-z0-9]*$/;

//只能是字母、数字、-
export const numberLetterHorizontalRegExp = /^[a-zA-Z0-9/-]+$/;
// 任意正整数，正小数（小数位不超过2位）
export const positiveDecimalRegExp = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
// 任意正整数，正小数（小数位不超过2位）
export const positiveDecimalAndSixIntRegExp = /^(([1-9][0-9]{0,5})|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
// 非0正整数不含小数
export const positiveIntegerRegExp = /^[1-9]\d*$/;
// 包含0正整数不含小数
export const positiveZeroIntegerRegExp = /^[0-9]\d*$/;
